import React, { useEffect, useState } from "react";
import "../styles/pages/maintenance.css";

import $ from "jquery";
import { callBackendAPI, convertDateAndTime, showMessage } from "../utils/helpers";
import { REST_API_METHODS } from "../utils/constants";
import Empty from "../components/common/Empty";
import TitleSetter from "../components/common/TitleSetter";
import MaintenanceList from "../components/common/MaintenanceList";
import IsLoadingHOC from "../components/common/IsLoadingHOC";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBellSlash } from "@fortawesome/free-solid-svg-icons";

const MaintenanceAlerts = (props) => {
  const { setLoading, isLoading } = props;
  const [maintenances, setMaintenance] = useState([]);
  let maintenanceId = 0;
  let assetId = 0;
  let userId = 0;

  useEffect(() => {
    fetchAssetsFn();
  }, []);

  const fetchAssetsFn = async () => {
    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem("user"));
      const response = await callBackendAPI(
        `getAssetsLinkedMaintenance?userId=${user._id}`,
        REST_API_METHODS.GET
      );
      if (!!response?.status) {
        setMaintenance(response.data);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const removeMaintenanceAlert = async (maintenanceId) => {
    try {
      setLoading(true);
      const response = await callBackendAPI(
        `removeMaintenanceAlert?id=${assetId}&userId=${userId}&maintenanceId=${maintenanceId}`,
        REST_API_METHODS.DELETE
      );
      if (!!response?.status) {
        $("#closeAlert").modal('hide');
        showMessage(response.message);
        fetchAssetsFn();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  const modalHandler = (mainId, event, user, id) => {
    assetId = id;
    maintenanceId = mainId;
    userId = user;
    $("#closeAlert").modal(event);
  }

  return (
    <>
      <TitleSetter title={"Maintenance Alerts"} />
      <div className="explorewrap termscondition maintenanceAlert-page">
        {/* <img src={process.env.PUBLIC_URL + "/images/left_bg.png"} alt="" /> */}
        <div className="container">
          <div className="explorecont ">
            <div className="cartPage-heading">
              <h3>Maintenance Alerts</h3>
            </div>
            {/* <h2></h2> */}
            <div className="faqwrap maintancealerts">
              <div className="accordion" id="accordionExample">
                {maintenances.map((alert, index) => (
                  <div className="item" key={index}>
                    <div className="item-header" id={"heading-" + index}>
                      <h2 className="mb-0">
                        <button
                          className="btn btn-link collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target={"#collapse-" + index}
                          aria-expanded="false"
                          aria-controls={"collapse-" + index}
                        >
                          <div className="row">
                            {/* <div className="col-md-4">
                              <div className="maintaincardimg">
                                <div className="productsimg">
                                  <img
                                    src={
                                      alert?.machine?.image ||
                                      "images/assets_img2.png"
                                    }
                                    alt=""
                                  />
                                </div>
                                <span>Assets Group Name</span>
                                <p className="text-capitalize">
                                  {alert?.machine?.name}
                                </p>
                              </div>
                            </div> */}

                            <div className="col-md-6">
                              <div className="maintaincardimg">
                                <div className="productsimg">
                                  <img
                                    src={
                                      alert?.assets.images[
                                        alert?.assets?.defaultImageIndex
                                      ].url || "images/assets_img2.png"
                                    }
                                    alt=""
                                  />
                                </div>
                                <div className="maintaince-dtls">
                                  <span>Asset Name</span>
                                  <p className="text-capitalize">
                                    {alert?.assets?.name}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="maintaincardimg">
                                <div className="productsimg">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="62.4"
                                    height="61.5"
                                    viewBox="0 0 62.4 61.5"
                                  >
                                    <g
                                      id="date-and-time"
                                      transform="translate(-45 -51.276)"
                                    >
                                      <path
                                        id="Path_280853"
                                        data-name="Path 280853"
                                        d="M104.408,109.662a6.877,6.877,0,0,0-5.448-4.834,29.054,29.054,0,0,0-4.1-.107h-.407a2.142,2.142,0,1,0,0,4.284h1.878c.6,0,1.214-.036,1.814.007-.036-.007-.064-.014-.093-.021a.157.157,0,0,0-.057-.007.482.482,0,0,0-.1-.014l.486.064-.236-.021a4.153,4.153,0,0,1,.664.186c-.1-.05-.207-.1-.314-.143l.514.214c-.064-.029-.136-.05-.2-.079.164.086.321.171.478.271a.27.27,0,0,0,.057.036c-.021-.021-.064-.043-.086-.064s-.071-.043-.071-.05H99.2c.007.007.021.007.029.021a.025.025,0,0,0,.014.007c.043.036.114.093.164.129l-.064-.043c.093.079.179.157.264.243s.129.136.193.207a.78.78,0,0,1-.043-.079,1.259,1.259,0,0,0,.086.121c.014.021.036.036.05.057.071.079.114.179.086.15a3.441,3.441,0,0,1,.193.357c-.021-.071-.05-.143-.079-.214l.214.514c-.043-.1-.093-.2-.136-.3a4.536,4.536,0,0,1,.207.814c-.007-.129-.021-.264-.036-.393.029.193.036.378.064.571a1.548,1.548,0,0,0-.029-.179c.029.471.021.943.021,1.414v5.641H49.284v-6.7c0-.143.007-.286.014-.428-.014.086-.029.164-.043.25.021-.193.043-.378.071-.571-.014.107-.021.214-.029.321a6.058,6.058,0,0,1,.193-.728c-.05.093-.093.193-.136.293l.214-.514c-.029.071-.057.15-.079.221a4.993,4.993,0,0,1,.286-.5.27.27,0,0,0,.036-.057c-.021.021-.043.05-.064.071s-.043.05-.05.057c.014-.021.064-.079.114-.143a.1.1,0,0,0,.021-.029c.007-.007.014-.021.021-.029l-.043.064c.079-.093.164-.186.25-.271s.136-.129.207-.193a.778.778,0,0,1-.079.043c.043-.029.079-.057.121-.086.021-.014.036-.036.057-.05.079-.071.171-.114.15-.086a3.442,3.442,0,0,1,.357-.193c-.071.021-.143.05-.214.079l.514-.214c-.1.043-.2.093-.3.136a4.941,4.941,0,0,1,.635-.179l-.214.021.143-.021c.114-.014.228-.036.336-.05l-.107.021a.168.168,0,0,0-.057.014l-.1.021c.55-.043,1.107-.014,1.657-.014h1.707a2.142,2.142,0,0,0,0-4.284H52.79a9.52,9.52,0,0,0-2.913.293,6.984,6.984,0,0,0-4.87,6.662C45,114.389,45,117.088,45,119.795v30.839a7.1,7.1,0,0,0,3.02,5.855A7.336,7.336,0,0,0,52.4,157.7H77.1c-.079-.136-.164-.264-.236-.4l-.086-.15c-.029-.057-.057-.107-.093-.164-.007-.007-.007-.014-.014-.029-.25-.457-.478-.921-.693-1.4-.036-.079-.064-.15-.1-.228-.021-.043-.036-.086-.057-.129s-.05-.121-.071-.178-.05-.121-.071-.179q-.139-.353-.257-.707c0-.007-.007-.014-.007-.029-.079-.229-.15-.457-.221-.685a18.636,18.636,0,0,1,2.72-16.23,19.38,19.38,0,0,1,3.742-3.863,19,19,0,0,1,4.77-2.678,18.57,18.57,0,0,1,11.446-.586,18.044,18.044,0,0,1,2.535.878c.228.1.457.2.685.314.014.007.021.007.029.014l.343.171c.114.057.228.121.343.179l.428.236c.107.057.207.121.314.186.357.214.714.457,1.05.693a.713.713,0,0,1,.171.136h0c.057,0,.114.071.171.114.014.007.021.007.029.014.243.179.486.357.714.55V113.09A11.746,11.746,0,0,0,104.408,109.662Z"
                                        transform="translate(0 -49.609)"
                                        fill="#1c3e7d"
                                      />
                                      <path
                                        id="Path_280854"
                                        data-name="Path 280854"
                                        d="M224.888,59.4h10.775a2.142,2.142,0,1,0,0-4.284H224.888a2.142,2.142,0,1,0,0,4.284Zm-4.206,6.355H214.42a2.142,2.142,0,1,1,0-4.284h1.05V53.42a2.142,2.142,0,1,1,4.284,0v8.047h.928a2.142,2.142,0,0,1,0,4.284ZM262.611,96.52h0a16.962,16.962,0,0,0-.985-3.642h0a17.067,17.067,0,0,0-1.328-2.435c-.143-.221-.293-.436-.45-.65-.057-.079-.114-.15-.171-.229a.445.445,0,0,0,.064.086c-.036-.05-.079-.1-.1-.129-.307-.378-.635-.743-.978-1.092s-.7-.685-1.071-1c-.107-.093-.214-.179-.321-.271a.618.618,0,0,0-.071-.05l-.007-.007-.021-.021-.007-.007c-.014-.007-.021-.014-.036-.021s-.029-.021-.043-.036c-.129-.093-.257-.193-.393-.286a17.17,17.17,0,0,0-2.713-1.528,16.832,16.832,0,0,0-3.67-1,17.277,17.277,0,0,0-3.842,0,13.923,13.923,0,0,0-5.9,2.2c-.328.214-.65.436-.957.664-.05.043-.107.086-.157.129-.157.129-.307.257-.464.393a17.066,17.066,0,0,0-1.671,1.7c-.1.114-.386.364-.414.507,0,.007.007,0,.014-.007-.021.036-.05.064-.071.1-.236.328-.464.671-.678,1.014a17.02,17.02,0,0,0-1.028,1.956,16.713,16.713,0,0,0-1,3.656,17.149,17.149,0,0,0,0,3.827v.007a16.468,16.468,0,0,0,.993,3.642V104a17.019,17.019,0,0,0,1.492,2.685c.121.179.25.35.378.528l.007.007.007.007c.086.107.171.207.257.314.328.386.671.764,1.028,1.114s.735.693,1.128,1.014c.107.086.214.164.314.25a1.126,1.126,0,0,0-.107-.086.819.819,0,0,1,.071.057q.289.214.578.407a15.893,15.893,0,0,0,2.513,1.378.025.025,0,0,0,.014.007,14.2,14.2,0,0,0,13.374-1.214q.493-.321.964-.664c.05-.043.107-.086.157-.129.157-.129.314-.257.464-.393a17,17,0,0,0,1.664-1.7c.1-.114.386-.357.414-.507,0-.007-.007,0-.014.007.021-.036.05-.064.071-.1.236-.328.464-.671.678-1.014a17.017,17.017,0,0,0,1.028-1.956,16.712,16.712,0,0,0,1-3.656,19.131,19.131,0,0,0,.114-1.921C262.718,97.8,262.682,97.155,262.611,96.52Zm-6.955,9.183a2.162,2.162,0,0,1-3.028,0c-.707-.7-1.414-1.407-2.114-2.106-.971-.964-1.935-1.928-2.906-2.9-.243-.236-.486-.471-.714-.714a2.385,2.385,0,0,1-.657-1.571c-.007-.114.014-.229.014-.336V91.55a2.142,2.142,0,1,1,4.284,0v6.026l.064.064q2.528,2.517,5.063,5.041A2.173,2.173,0,0,1,255.656,105.7Zm-9.939-39.951h-6.262a2.142,2.142,0,1,1,0-4.284h1.007v-7.94a2.142,2.142,0,1,1,4.284,0v7.94h.971a2.142,2.142,0,0,1,0,4.284Z"
                                        transform="translate(-155.332)"
                                        fill="#1c3e7d"
                                      />
                                    </g>
                                  </svg>
                                </div>
                                <div className="maintaince-dtls">
                                  <span>Installation Date & Time</span>
                                  <p>
                                    {convertDateAndTime(alert.assetsInstallDate)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="faqcloseicons">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="29.232"
                              height="16.653"
                              viewBox="0 0 29.232 16.653"
                            >
                              <path
                                id="Path_1298"
                                data-name="Path 1298"
                                d="M1230.461,974.165c.519-.525,1-1.021,1.492-1.511q5.063-5.066,10.129-10.132a1.558,1.558,0,0,1,1.7-.412,1.524,1.524,0,0,1,1.074,1.335,1.567,1.567,0,0,1-.505,1.364q-2.823,2.816-5.64,5.639l-6.977,6.977a1.638,1.638,0,0,1-2.6-.008q-6.31-6.308-12.62-12.614a1.666,1.666,0,0,1-.553-1.634,1.61,1.61,0,0,1,2.734-.766c1.108,1.083,2.194,2.191,3.289,3.287l8.173,8.185C1230.243,973.964,1230.335,974.047,1230.461,974.165Z"
                                transform="matrix(-1, -0.017, 0.017, -1, 1227.891, 999.639)"
                                fill="#1b3e7c"
                              />
                            </svg>
                          </div>
                        </button>
                      </h2>
                    </div>
                    <div
                      id={"collapse-" + index}
                      className="collapse"
                      aria-labelledby={"heading-" + index}
                      data-parent="#accordionExample"
                    >
                      <div className="mysubmittedrequested">
                        <MaintenanceList
                          alerts={alert.maintenanceAlerts}
                          user={alert?.user}
                          id={alert._id}
                          fetchAssetsFnCallback={fetchAssetsFn}
                          modalHandler={modalHandler}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                {!maintenances.length && !isLoading && (
                  <div className="emptycart-wrap">
                    <p> <Empty message="No maintenance alerts found." /></p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade modal-center"
        id="closeAlert"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
      >
        <div className="modal-dialog custom_modal_wrap" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="logoutpopupwrap">
                <h2 className="modlheading">Mark Complete</h2>
                <FontAwesomeIcon
                  className="w-100 h1 fonticon"
                  color={"red"}
                  icon={faBellSlash}
                />
                <p className="mt-4 black-text">Are you sure you want to complete?</p>
                <div className="common_btn">
                  <button
                    type="button"
                    onClick={() => removeMaintenanceAlert(maintenanceId)}
                  >
                    Yes
                  </button>
                  <button type="button" data-dismiss="modal">
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IsLoadingHOC(MaintenanceAlerts);
